import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { AccessService } from 'src/app/providers/access/access.service';
@Component({
  selector: 'app-add-hospital',
  templateUrl: './add-hospital.page.html',
  styleUrls: ['./add-hospital.page.scss'],
})
export class AddHospitalPage implements OnInit {
  hospitalForm: FormGroup;
  hospitalList: any[] = [];
  hospitalListSorted: any[] = [];
  successMassage= 'We have received your request and your new hospital will be added within one business day.';
  constructor(
    private navCtrl: NavController,
    public formBuilder: FormBuilder,
    public apiService: ApiService,
    public toastService: ToastService,
    public accessService: AccessService,
  ) {
    this.hospitalForm = this.formBuilder.group({
      hospital: ['', [Validators.required]],
    });
  }

  ngOnInit() {}

  ionViewWillEnter () {    
    this.getHospitalList();
  }
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  onSubmitForm() {
    if (this.hospitalForm.valid) {
      this.toastService.presentLoading();
      this.apiService.post('add-hospital', this.hospitalForm.value).subscribe(
        (res) => {
          this.toastService.dismissLoading();
          if (res.error === false) {
            //console.log('Form Value:: ', this.hospitalForm.value);
            this.navCtrl.navigateForward(['/confirmation-page'], {
              queryParams: {
                state : this.successMassage,
                hasAddButton:true
              },
          });
          }
        },
        (err) => {
          this.toastService.presentToast('error','Something went wrong.');
          this.toastService.dismissLoading();
          //console.log(err);
        }
      );
    } else {
      this.hospitalForm.controls.name.markAllAsTouched();
    }
  }

  getHospitalList() {
    this.apiService.post('hospital-list', {}).subscribe(
      (res) => {
        if (res.error === false) {
          this.hospitalList = res.data.hospitals;
        }
      },
      (err) => { }
    );
  }
}
